/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Table, Input, Dropdown, Button, Select, DatePicker } from 'antd'
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { getPopupContainer } from '../../helpers/popUp';
import { getLocales } from './newTable';

const Styles = styled.div`
  .searchBox {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-bottom: 20px;
    .searchInput:not(:first-of-type) {
      margin-top: 10px;
    } }
  .searchInput {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    input {
      border-top-left-radius: 0;
      botder-bottom-left-radius: 0;
      border-left: none;
      width: -webkit-fill-available;
    }
    .ant-select {
      width: -webkit-fill-available;
    }
    .label {
      width: fit-content;
      padding: 4px 12px;
      display: flex;
      max-height: 32px;
      overflow: hidden;
      flex-direction: column;
      justify-content: start;
      align-items: center;
      background-color: #fafafa;
      border: 1px solid #d9d9d9;
      border-radius: 2px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    &:not(:first-of-type) {
      border-radius: 0;
      border-right: none;
    }
    button {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
`

export default function Tablestake({
  columns = [],
  data = [],
  options = {},
  defaultFilters = {},
  style = {},
  pagination = null,
  loading = false,
  onChange = () => { },
  onFilterChange = () => { },
  rowSelection = false,
  rowKey = 'id',
  expandable = false,
  expandIcon = null,
  onRow = () => { },
  showFilters = true,
}) {
  const { t } = useTranslation();
  const primarySearch = columns.find(col => col.primarySearch) || columns[0];
  const [source, setSource] = useState([]);
  const [selectedColumns, setSelectedColumns] = useState([primarySearch.dataIndex].concat(Object.keys(defaultFilters)));
  const [withSearchValue, setSearchValues] = useState(defaultFilters);

  useEffect(() => {
    if (data.length) {
      setSource(data);
    }
  }, [data])

  useEffect(() => {
    if (data.length && Object.keys(withSearchValue).length) {
      setSource(data.filter(item => {
        return Object.keys(withSearchValue)
          .map(key => {
            if (moment.isMoment(withSearchValue[key])) {
              return moment(item[key]).isSame(withSearchValue[key], 'D');
            }
            let sValue = withSearchValue[key] ?
              withSearchValue[key].toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9]/g, '') : '';
            if (options && options[key] && Array.isArray(options[key])) {
              const opt = options[key].find(o => o.value === sValue);
              if (opt && opt.label) {
                sValue = opt.label;
              }
            }

            const rgxp = new RegExp(`${sValue}`, 'gmi');

            if (Array.isArray(item[key])) {
              return item[key].map(itm => itm && rgxp.exec(itm.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9]/g, '')) !== null).includes(true);
            }

            if (typeof item[key] === 'string') {
              return item[key] && rgxp.exec(item[key].toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9]/g, '')) !== null;
            }

            return false;
          })
          .every(evl => evl)
      }));
    } else {
      setSource(data);
    }
    onFilterChange(withSearchValue);
  }, [withSearchValue, data])

  const getTitle = (dataIndex) => (columns.find(col => col.dataIndex === dataIndex) || { title: '' }).title || '';
  const getColumn = (dataIndex) => columns.find(col => col.dataIndex === dataIndex) || {};

  const getSearchOptions = () => {
    return columns.filter(col =>
      col.search && !selectedColumns.includes(col.dataIndex))
      .map((col, ind) => ({
        key: ind,
        onClick: () => {
          setSelectedColumns(selectedColumns.concat([col.dataIndex]))
        },
        label: col.title,
      }));
  }

  function handleSearch(dataIndex, search, isDropdown) {
    if (search && (search.length || moment.isMoment(search))) {
      const current = withSearchValue;
      current[dataIndex] = search;
      setSearchValues({ ...current });
    } else {
      setSearchValues({
        ...Object.keys(withSearchValue).reduce((values, key) => {
          if (!search || !search.length) {
            delete values[dataIndex];
          };
          return values;
        }, withSearchValue)
      });
    }
  }

  return <Styles style={style}>
    {showFilters && (
      <div className="searchBox">
        <div className="searchInput">
          <Dropdown
            menu={{ items: getSearchOptions() }}
            trigger={['click']}>
            <Button icon={<PlusOutlined />}>{t('Add filter')}</Button>
          </Dropdown>
          <Input
            defaultValue={defaultFilters[primarySearch.dataIndex] || null}
            className="primary"
            placeholder={`${t('Search by')} ${primarySearch.title}`}
            onKeyUp={(ev) => handleSearch(primarySearch.dataIndex, ev.target.value)}
          />
        </div>
        {selectedColumns
          .filter(dataIndex => dataIndex !== primarySearch.dataIndex)
          .map((dataIndex, ind) => (
            <div key={`${dataIndex}-${ind}`} className="searchInput">
              <div className="label">{getTitle(dataIndex)}</div>
              {!getColumn(dataIndex).searchType || getColumn(dataIndex).searchType === 'text' ? <Input
                defaultValue={defaultFilters[dataIndex] || null}
                placeholder={t('Search')}
                onKeyUp={(ev) => handleSearch(dataIndex, ev.target.value)}
              /> : null}
              {getColumn(dataIndex).searchType === 'dropdown' ?
                <Select
                  {...getPopupContainer()}
                  allowClear
                  showSearch
                  placeholder={t('Select')}
                  defaultValue={defaultFilters[dataIndex]}
                  onChange={ev => handleSearch(dataIndex, ev)}>
                  {options && options[dataIndex] && options[dataIndex].map((opt, ind) => (
                    <Select.Option key={ind} value={opt.label}>{opt.label}</Select.Option>
                  ))}
                </Select> : null}
              {getColumn(dataIndex).searchType === 'date' ?
                <DatePicker
                  defaultValue={defaultFilters[dataIndex] ? moment(defaultFilters[dataIndex]) : null}
                  style={{ width: '100%' }} onChange={ev => handleSearch(dataIndex, moment(ev).format('YYYY-MM-DD'))} />
                : null}
              <Button
                type="danger"
                icon={<MinusOutlined />}
                onClick={() => {
                  setSelectedColumns(selectedColumns.filter(col =>
                    col !== dataIndex));
                  setSearchValues({
                    ...Object.keys(withSearchValue).reduce((values, key) => {
                      delete values[dataIndex];
                      return values;
                    }, withSearchValue)
                  });
                }}></Button>
            </div>
          ))}
      </div>
    )}
    <Table
      size="small"
      locale={getLocales(t)}
      rowKey={rowKey}
      rowSelection={rowSelection}
      loading={loading}
      columns={columns}
      dataSource={source}
      pagination={pagination}
      onChange={onChange}
      expandable={expandable}
      onRow={onRow}
      {... (expandIcon ? {
        expandIcon: ({ expanded, onExpand, record, expandable }) => expandable ? expanded ? (
          <button
            type="button"
            className={`ant-table-row-expand-icon ant-table-row-expand-icon-expanded hide-row-${record.id}`}
            aria-label="Expand row"
            onClick={e => onExpand(record, e)}
          ></button>
        ) : (
          <button
            type="button"
            className={`ant-table-row-expand-icon ant-table-row-expand-icon-collapsed show-row-${record.id}`}
            aria-label="Collapse row"
            onClick={e => onExpand(record, e)}
          ></button>
        ) : <button type="button" class="ant-table-row-expand-icon ant-table-row-expand-icon-spaced" aria-label="Expand row"></button>
      } : {})}
    />
  </Styles>;
}
